import { PatientLegalCapacity } from '@dreryk/egabinet-referral-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { referralToPsychiatricHospitalTranslationKeys } from '../../../translations';

const INFORMATION_ABOUT_PATIENT_FIELD_NAME = 'informationAboutPatient';

type InformationAboutPatientFormBeanPart = {
   [INFORMATION_ABOUT_PATIENT_FIELD_NAME]: PatientLegalCapacity | null;
};

type InformationAboutPatientSelectProps = {
   readonly register: BindingCreator<InformationAboutPatientFormBeanPart, typeof INFORMATION_ABOUT_PATIENT_FIELD_NAME>;
};

const items: PatientLegalCapacity[] = [
   'NOT_INCAPACITATED',
   'PARTIALLY_INCAPACITATED',
   'COMPLETELY_INCAPACITATED',
   'NO_INFORMATION',
];

const useTriggerLabelExtractor = (): ((item: PatientLegalCapacity) => string) => {
   const translate = useTranslate();
   return (item: PatientLegalCapacity) =>
      translate(referralToPsychiatricHospitalTranslationKeys.informationAboutPatientItems[item]);
};

export const InformationAboutPatientSelect = (props: InformationAboutPatientSelectProps): JSX.Element => {
   return (
      <Select
         testId={'informationAboutPatient'}
         triggerLabelExtractor={useTriggerLabelExtractor()}
         label={referralToPsychiatricHospitalTranslationKeys.informationAboutPatient}
         controller={props.register(INFORMATION_ABOUT_PATIENT_FIELD_NAME, { required: true })}
         placeholder={referralToPsychiatricHospitalTranslationKeys.choose}
      >
         <Select.List<PatientLegalCapacity> items={items}>
            {(item) => (
               <Select.Item
                  testId={item}
                  item={item}
                  label={referralToPsychiatricHospitalTranslationKeys.informationAboutPatientItems[item]}
               />
            )}
         </Select.List>
      </Select>
   );
};
